import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const updateEmployeeType = createAsyncThunk(
  "updateEmployeeType",
  async ({ id, data, form }) => {
    const token = localStorage.getItem("auth_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const response = await axiosHttp.patch(`et/update?id=${id}`, data, config);

    form.resetFields();
    message.success("Employee Type successfully updated!");
    return response.data;
  }
);

const employeeTypeUpdateSlice = createSlice({
  name: "employeeTypeUpdate",
  initialState: {
    isLoading: false,
    error: null,
    data: null,
  },
  reducers: {
    clearUpdateStatus: (state) => {
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateEmployeeType.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(updateEmployeeType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(updateEmployeeType.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { clearUpdateStatus } = employeeTypeUpdateSlice.actions;
export default employeeTypeUpdateSlice.reducer;
